export function toUrl(url: string, location: Pick<Location, 'assign'> = window.location) {
  location.assign(url);
}

export function withTvsState(baseUrl: string, state: string, extraParams?: Record<string, string>): string {
  const url = new URL(baseUrl);
  url.searchParams.set('tvs_state', state);
  Object.entries(extraParams ?? {}).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });
  return url.toString();
}
